import React from 'react';
import { DashboardSummary } from '../components/dashboard/DashboardSummary';

export default function NewDashboardPage() {
    return (
        <div className="min-h-screen bg-slate-950">
            <DashboardSummary />
        </div>
    );
}
